import { useTranslation } from "react-i18next";
import { Label } from "../../forms/Label/Label";
import { Select, TSelectOption } from "../../forms/Select";
import { TEmployeeStatus } from "@/types/filter";
import { useMemo } from "react";

type TStatusDropdownProps = {
  isLoading?: boolean;
  selVal?: string | boolean;
  onStatusSel: (value: string) => void;
  component?: string;
  statusData?: TEmployeeStatus[];
  // onStatusChange?: (value: string | boolean) => void;
};

const StatusDropdown = ({
  selVal,
  onStatusSel,
  // component,
  statusData,
  // onStatusChange,
}: TStatusDropdownProps) => {
  const { t } = useTranslation(["common"]);

  const tranformedValues = useMemo(() => {
    return statusData?.map((item) => {
      return {
        value: String(item?.value),
        label: item?.status,
      };
    });
  }, [statusData]);

  return (
    <>
      <Label weight={"medium"} htmlFor="Status">
        {t("FILTER.STATUS")}
      </Label>
      <Select
        name="Status"
        options={tranformedValues ?? []}
        value={
          tranformedValues?.find((opt) => opt.value === String(selVal)) ?? null
        }
        onChange={(option: TSelectOption | null) => {
          onStatusSel(option?.value ?? "");
        }}
        getOptionLabel={(option: TSelectOption) => option.label}
        getOptionValue={(option: TSelectOption) => option.value}
        placeholder={t("FILTER.STATUS")}
        isClearable={false}
      />
    </>
  );
};

export default StatusDropdown;
